import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { showBetterPrice } from "../../../utils/showBetterPrice";
//Layout And Css's
import styles from "./Trades.module.scss";
import HeaderCrypto from "../../Layouts/marketLayout/HeaderCrypto";
//Components From @MUI
import TextField from "@mui/material/TextField";
import RTL from "../../../helpers/direction/RTL";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { addComma } from "../../../utils/addComma";
//COIN Icons
import starLight from "../../../styles/icon/star-like.svg";
import starFill from "../../../styles/icon/starFill.svg";
import ArrowIcon from "../../../styles/icon/arrowdown.svg";
import SearchIcon from "../../../styles/icon/Search_light.svg";

///STORE
import { addFavoriteCoins } from "../../../actions/favoriteCoins";
import { useDispatch, useSelector } from "react-redux";
import { Triangle } from "react-loader-spinner";
import ViewportList from "react-viewport-list";
/////

//FOR ACCORDION
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
////
export default function Trades() {
  const ref = useRef(null);

  let TAKE_DATA = useSelector((state) => state.market.data);
  //For check LocalStorage
  let favUserCoins = useSelector((state) => state.favCoins);
  const dispatch = useDispatch();
  //Search and Filter's Options
  const [filterOptions, setFilterOptions] = useState({
    searchItem: "",
    sortByFav: false,
    priceBy: "dollar",
  });
  const LIST_OF_COINS =
    TAKE_DATA && !filterOptions.sortByFav
      ? TAKE_DATA.filter(
          (coin) =>
            coin.faName.includes(filterOptions.searchItem) ||
            coin.name
              .toLowerCase()
              .includes(filterOptions.searchItem.toLowerCase()) ||
            coin.symbol
              .toLowerCase()
              .includes(filterOptions.searchItem.toLowerCase())
        )
      : TAKE_DATA &&
        filterOptions.sortByFav &&
        TAKE_DATA.filter((coin) => favUserCoins.includes(coin.name));
  const [checkFocus, setCheckFocus] = useState("");
  const [openFilterModal, setOpenModalFilter] = useState(false);
  const handleOpenModal = () => setOpenModalFilter(true);
  const handleCloseModal = () => setOpenModalFilter(false);
  //Modal Styles
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 220,
    height: 153,
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: 1,
    p: 4,
  };
  return (
    <>
      <Modal open={openFilterModal} onClose={handleCloseModal}>
        <Box sx={style} className="changeBackgroundColorToHardBlack">
          <div className={styles.modal_filter_container}>
            <div className={`font_color_white ${styles.text_modal}`}>
              نمایش قیمت
            </div>
            <div className={styles.line_modal}></div>
            <div className={styles.input_radio_container}>
              <label htmlFor="dollar" className={styles.labelClass}>
                <input
                  type="radio"
                  id="dollar"
                  name="select_price"
                  value="dollar"
                  checked={filterOptions.priceBy === "dollar"}
                  onChange={(e) =>
                    setFilterOptions({
                      ...filterOptions,
                      priceBy: e.target.value,
                    })
                  }
                />
                <div className={styles.checkbox}></div>
                <div className={`font_color_white ${styles.text_radio}`}>
                  قیمت به دلار
                </div>
              </label>
              <div className={styles.line_modal_2}></div>
              <label htmlFor="buy_us" className={styles.labelClass}>
                <input
                  type="radio"
                  id="buy_us"
                  name="select_price"
                  value="arzfi_price"
                  checked={filterOptions.priceBy === "arzfi_price"}
                  onChange={(e) =>
                    setFilterOptions({
                      ...filterOptions,
                      priceBy: e.target.value,
                    })
                  }
                />
                <div className={styles.checkbox}></div>
                <div className={`font_color_white ${styles.text_radio}`}>
                  قیمت خرید از ما
                </div>
              </label>
              <div className={styles.line_modal_2}></div>
              <label htmlFor="sell_us" className={styles.labelClass}>
                <input
                  type="radio"
                  id="sell_us"
                  name="select_price"
                  value="arzfi_buy"
                  checked={filterOptions.priceBy === "arzfi_buy"}
                  onChange={(e) =>
                    setFilterOptions({
                      ...filterOptions,
                      priceBy: e.target.value,
                    })
                  }
                />
                <div className={styles.checkbox}></div>
                <div className={` font_color_white ${styles.text_radio}`}>
                  قیمت فروش به ما
                </div>
              </label>
            </div>
          </div>
        </Box>
      </Modal>
      <div className={styles.container}>
        <header>
          <HeaderCrypto />
        </header>
        <div className={styles.searchBox_container}>
          <div className={styles.search_input_place}>
            <RTL>
              <TextField
                className={`darkModeInTradeList ${styles.number_login_input}`}
                label="جستجو"
                color="success"
                onFocus={() => setCheckFocus("search")}
                onBlur={() => setCheckFocus("")}
                autoComplete="off"
                onChange={(e) =>
                  setFilterOptions({
                    ...filterOptions,
                    searchItem: e.target.value,
                  })
                }
              />
              <div
                className={`${styles.icon_place} ${styles.first_input_icon} ${
                  checkFocus === "search" ? styles.icon_place_active : ""
                }`}
              >
                <img
                  src={SearchIcon}
                  alt="find"
                  className="convertPicToGreen"
                />
              </div>
            </RTL>
          </div>
        </div>
        {/* Top of code for filter (Search) between data */}
        <div className={styles.filtersBox}>
          <div className={styles.filter_all}>
            <button
              className={`addBorderWhite font_color_white ${
                !filterOptions.sortByFav ? styles.button_active : ""
              }`}
              onClick={() =>
                setFilterOptions({ ...filterOptions, sortByFav: false })
              }
            >
              همه
            </button>
          </div>
          <div className={styles.filter_popular}>
            <button
              className={` addBorderWhite font_color_white ${
                filterOptions.sortByFav === true ? styles.button_active : ""
              }`}
              onClick={() =>
                setFilterOptions({ ...filterOptions, sortByFav: true })
              }
            >
              ارزهای محبوب
            </button>
          </div>
          <div className={` ${styles.filter_price}`}>
            <button onClick={handleOpenModal} className="font_color_white">
              <img src={ArrowIcon} alt="" className="convertPicToGreen" />{" "}
              {filterOptions.priceBy === "dollar"
                ? "قیمت به دلار"
                : filterOptions.priceBy === "arzfi_price"
                ? "قیمت خرید از ما"
                : "قیمت فروش به ما"}
            </button>
          </div>
        </div>
        {/*Top Of Code for Filter Between Data */}
        <div className={styles.table_titles}>
          <div className={`font_color_white ${styles.coins_name}`}>
            <span>نماد/نام ارز</span>
          </div>
          <div className={` font_color_white ${styles.coins_price}`}>
            <span>قیمت/تغییرات</span>
          </div>
        </div>

        {/*Bottom of codes for show data of coins */}
        <div className={styles.coins_info_place}>
          {_.isEmpty(LIST_OF_COINS) && (
            <div className={styles.loadingBar}>
              <Triangle color="#10D078" height={80} width={80} />
            </div>
          )}
          <div className="trades_list_basic">
            <ul className={styles.accordion_ul}>
              <div className="scroll-container" ref={ref}>
                <ViewportList
                  viewportRef={ref}
                  items={LIST_OF_COINS}
                  itemMinSize={40}
                >
                  {(item) => (
                    <li
                      key={item.name + item.symbol}
                      className="darkModeInTradeList"
                    >
                      <Accordion>
                        <AccordionSummary>
                          <div className={`${styles.accordion_container} `}>
                            <div className={styles.coin_isFavorite}>
                              <img
                                src={
                                  favUserCoins.includes(item.name)
                                    ? starFill
                                    : starLight
                                }
                                alt="like"
                                width={16}
                                height={16}
                                onClick={() =>
                                  dispatch(addFavoriteCoins(item.name))
                                }
                              />
                            </div>
                            <div className={styles.coin_pic}>
                              <img
                                src={`/images/assets-logo/${item.symbol}.png`}
                                alt={item.symbol}
                                width={36}
                                height={36}
                              />
                            </div>
                            <div
                              className={`darkModeInTradeListForTexts ${styles.coin_eng_name}`}
                            >
                              {item.name}/{item.symbol}
                            </div>
                            <div
                              className={`darkModeInTradeListForTexts ${styles.coin_fa_name}`}
                            >
                              {item.faName}
                            </div>
                            <div
                              className={`darkModeInTradeListForTexts ${styles.coin_price}`}
                            >
                              {filterOptions.priceBy === "dollar" ? (
                                <>
                                  <div>{showBetterPrice(item.usdtPrice)}</div>
                                  <div>$</div>
                                </>
                              ) : filterOptions.priceBy === "arzfi_buy" ? (
                                <>
                                  <div>{addComma(item.arzfi_buy_price)}</div>
                                  <div>تومان</div>
                                </>
                              ) : (
                                <>
                                  <div>{addComma(item.arzfi_price)}</div>
                                  <div>تومان</div>
                                </>
                              )}
                            </div>
                            <div
                              className={`${styles.coin_changes} ${
                                item.percent_change_7d >= 0
                                  ? styles.coin_changes_positive
                                  : styles.coin_changes_negative
                              }`}
                            >
                              {item.percent_change_7d}%
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className={styles.accordion_container_invisible}>
                            <div className={styles.line_into_accordion}></div>
                            <div className={styles.button_of_coin}>
                              <Link to={`/convert-custom?coin=${item.symbol}`}>
                                <button
                                  className={`${styles.order_coin_btn} ${styles.order_btn}`}
                                >
                                  سفارش گذاری
                                </button>
                              </Link>
                              <Link to={`/convert?coin=${item.symbol}`}>
                                <button className={styles.change_coin_btn}>
                                  تبدیل
                                </button>
                              </Link>
                              <Link to={`/sell/${item.symbol}`}>
                                <button className={styles.sell_coin_btn}>
                                  فروش
                                </button>
                              </Link>
                              <Link to={`/buy/${item.symbol}`}>
                                <button className={styles.buy_coin_btn}>
                                  خرید
                                </button>
                              </Link>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </li>
                  )}
                </ViewportList>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

//
//

//
